export enum PROPERTY_CHANNELS {
  HOTEL = 'accommodation',
  CAR = 'vehicle',
}
